import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
import SidebarAddress from '../../components/SidebarAddress/SidebarAddress';
import { deliveryTypeStore } from '../../store/deliveryTypeStore';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { ICustomerAddress } from 'src/types/user';
import { hasBranch } from 'src/utils/helpers';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import ScrollableList from 'src/view/components/ScrollableList/ScrollableList';

const SidebarAddressList: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    // If a customer is not selected, then there cannot be addresses of previous orders
    if (modalStore.deliveryType?.customer) {
      deliveryTypeStore.fetchAddresses(1);
    }
  }, []);

  const renderAddress = (address: ICustomerAddress | undefined, index: number) => {
    return <SidebarAddress key={address?.id || index} address={address} />;
  };

  /**
   * Current selected location.
   */
  const location = useMemo(() => {
    return deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].location;
  }, [deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].location]);

  /**
   * Current selected branch.
   */
  const branch = useMemo(() => {
    return deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].branch;
  }, [deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].branch]);

  const submitButtonDisabled = useMemo((): boolean => {
    return !deliveryTypeStore.isEditableOrder || !location?.area_id || !branch || !hasBranch(branch.id);
  }, [location, branch, deliveryTypeStore.isEditableOrder]);

  return (
    <div className="d-flex flex-column flex-1">
      {/* address list */}
      <ScrollableList
        pages={deliveryTypeStore.addressesPaginationPages}
        list={deliveryTypeStore.addressesPagination.data}
        last_page={deliveryTypeStore.addressesPagination.last_page}
        current_page={deliveryTypeStore.addressesPagination.current_page}
        refreshing={deliveryTypeStore.addressesPagination.refreshing}
        loading={deliveryTypeStore.addressesPagination.loading}
        fetch={deliveryTypeStore.fetchAddresses}
        renderItem={renderAddress}
        emptyListText="no_addresses_found"
        autoFetch={false}
        scrollToTop={false}
      />
      {/* submit button */}
      <Button
        title={localeStore.t('deliver_here')}
        onClick={deliveryTypeStore.submit}
        disabled={submitButtonDisabled}
        loading={deliveryTypeStore.loading}
        size="large"
        stretched
      />
    </div>
  );
});

export default SidebarAddressList;
